import React from 'react'
import { Box, Typography } from '@mui/material'
import { makeStyles } from 'tss-react/mui'
import { useTranslation } from 'react-i18next'
import ClickArrow from '@talentinc/gatsby-theme-ecom/images/clickarrow.svg'
import ProgressBarIcon from './ProgressBarIcon'

interface Props {
  isActive: boolean
  title: string
  description: string
  onClick: () => void
  index: number
  img: any
  tabTimeOutInSecond: number
  showTimer: boolean
  classes?: {
    step?: string
    activeStep?: string
  }
}

const IntervalSliderItem = ({
  isActive,
  title,
  description,
  index,
  img,
  onClick,
  tabTimeOutInSecond,
  showTimer,
  classes: additionalClasses = {},
}: Props) => {
  const { t } = useTranslation()
  const { classes, cx } = useStyles()

  return (
    <Box
      onClick={onClick}
      className={cx(
        classes.step,
        additionalClasses.step,
        isActive ? cx(classes.activeStep, additionalClasses.activeStep) : null
      )}
    >
      <Box className={classes.column}>
        <Box className={classes.row}>
          <Box className={classes.number}>
            <Typography>{index + 1}</Typography>
          </Box>
          <Box className={classes.text}>
            <Typography variant={'h3'}>{t(title)}</Typography>
          </Box>
          {!isActive ? (
            <Box>
              <img src={ClickArrow} alt="Arrow" />
            </Box>
          ) : showTimer ? (
            <ProgressBarIcon tabTimeOutInSecond={tabTimeOutInSecond} />
          ) : null}
        </Box>
        {isActive && (
          <Typography className={classes.description}>{t(description)}</Typography>
        )}
      </Box>
      <Box>
        {isActive && (
          <img
            className={cx({
              [classes.image]: true,
              [classes.imageMobile]: true,
            })}
            src={img}
            alt=""
          />
        )}
      </Box>
    </Box>
  )
}

export default IntervalSliderItem

const useStyles = makeStyles()((theme) => ({
  step: {
    display: 'flex',
    borderRadius: 24,
    flexDirection: 'column',
    marginBottom: 8,
    cursor: 'pointer',
    '&:hover': {
      background: theme.colors.neutral[5],
    },
  },
  activeStep: {
    background: theme.colors.neutral[5],
    [theme.breakpoints.down(theme.breakpoints.values.sm)]: {
      '& > div': {
        paddingBottom: 0,
      },
    },
  },
  description: {
    fontSize: 19,
    color: theme.colors.neutral[60],
    marginTop: 8,
    marginLeft: 40,
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  column: {
    display: 'flex',
    flexDirection: 'column',
    padding: 24,
    [theme.breakpoints.down(theme.breakpoints.values.sm)]: {
      padding: 16,
    },
  },
  number: {
    borderRadius: 20,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: theme.colors.neutral[10],
    marginRight: 12,
    width: 28,
    height: 28,
    lineHeight: 24,
    fontSize: 20,
    color: theme.colors.neutral[60],
  },
  text: {
    display: 'flex',
    marginRight: 8,
    flex: 1,
    flexDirection: 'column',
    alignItems: 'flex-start',
    '& h3': {
      margin: 0,
      lineHeight: '28px',
      fontSize: 23,
    },
  },
  image: {
    width: '100%',
    height: 'auto',
  },
  imageMobile: {
    [theme.breakpoints.up(theme.breakpoints.values.sm)]: {
      display: 'none',
    },
  },
}))
